(function () {
  'use strict';

  var id = 'line-chart';
  angular.module('wsLrs.cards').factory(id + '.Utils', ['$filter', '$sanitize', '$location', '$q', 'AggregationUtils', 'CardQueryResource', 'ChartUtils', 'QueryES', 'wsColors', 'Utils', 'Logger', 'HighchartsInterface', 'MomentInterface', function ($filter, $sanitize, $location, $q, AggUtils, CardQueryResource, ChartUtils, QueryES, wsColors, Utils, Logger, HighchartsInterface, MomentInterface) {
    // background methods, etc.
    var existy = Utils.existy,
      forEach = Utils.forEach,
      sortBy = Utils.sortBy,
      isNull = Utils.isNull,
      isUndefined = Utils.isUndefined,
      isArray = Utils.isArray,
      map = Utils.map,
      chain = Utils.chain,
      filter = Utils.filter,
      findWhere = Utils.findWhere,
      clamp = Utils.clamp,
      assignMethods = Utils.assignMethods;

    // highcharts methods
    var getColorOption = HighchartsInterface.getColorOption;

    // moment methods
    var validateMoment = MomentInterface.validate,
      momentToDate = MomentInterface.toDate,
      utc = MomentInterface.utc,
      utcToDate = MomentInterface.utcToDate,
      duration = MomentInterface.duration;

    // line-chart methods
    var _fetchData = function _fetchData(cfg) {
      cfg = cfg || {};

      // For line charts, allow up to 1000 data points... i.e., can plot 2000 days.
      cfg.params._limit = 2000;
      var path = "/line-chart/data";
      var params = cfg.params;
      return CardQueryResource.getWithProgress(path, cfg.cardId, params, cfg.cardToPreview, 'line-chart-' + cfg.cardId);
    };
    var _fetchEventLines = function _fetchEventLines(cfg) {
      cfg = cfg || {};
      var path = "/line-chart/event-lines";
      var params = cfg.params;
      return CardQueryResource.get(path, cfg.cardId, params, cfg.cardToPreview);
    };
    var fetchData = function fetchData(cfg) {
      cfg = cfg || {};
      cfg.params = cfg.params || {};
      var fetchPromise = $q.all([_fetchData(cfg), _fetchEventLines(cfg)]);

      // Special handling for 'includeUnfilteredLine' configuration option. Go fetch a line that doesn't
      // use the current quick filter or selected dimensions and include it in the results...
      var shouldFetchUnfilteredLine = $location.search().filter;
      if (!shouldFetchUnfilteredLine && cfg.params.dimensionIds) {
        var dimIds = cfg.params.dimensionIds;
        shouldFetchUnfilteredLine = dimIds.length > 0 && dimIds.indexOf(-1) >= 0;
      }
      if (cfg.cardConfig && cfg.cardConfig.includeUnfilteredLine && shouldFetchUnfilteredLine) {
        var cfgCopy = angular.copy(cfg);
        cfgCopy.params = cfgCopy.params || {};
        cfgCopy.params.filter = {};
        cfgCopy.params.dimensionIds = [];
        fetchPromise = $q.all([fetchPromise, _fetchData(cfgCopy)]).then(function (responses) {
          var singleDimension = cfg.cardConfig && cfg.cardConfig.dimensions && cfg.cardConfig.dimensions.length === 1;

          // In the single dimension case, merge results by
          // creating a map based on common time values
          if (singleDimension) {
            var aggsByValue = {};
            forEach(responses[1].results[0].result.data, function (d) {
              aggsByValue[d.values[0].value] = d.aggregations;
            });
            forEach(responses[0][0].results[0].result.data, function (d) {
              Array.prototype.push.apply(aggsByValue[d.values[0].value], d.aggregations);
            });
            return [responses[1], responses[0][1]];

            // In the multi dimension case, add special 'Unfiltered' dimension to results
          } else {
            var finalResults = responses[0][0].results[0].result;
            var finalData = finalResults.data;
            forEach(responses[1].results[0].result.data, function (d) {
              d.values = [d.values[0], {
                value: -1,
                label: 'Unfiltered'
              }];
              finalData.push(d);
              finalResults.count += 1;
            });
            return responses[0];
          }
        });
      }
      return fetchPromise;
    };
    var ensureDataSize = function ensureDataSize($scope, data) {
      var underLimit = data.length < 3500;
      if (!underLimit) {
        $scope.hasData = false;
        $scope.noDataMsg = "Too many data points to display. Please narrow your results.";
      }
      return underLimit;
    };
    var getStatementDownloadUrl = function getStatementDownloadUrl(cardId) {
      return QueryES.queryExportUrl(cardId, true, id);
    };
    var isTimeBasedDimension = function isTimeBasedDimension(config) {
      return config && config.dimensions[0] && config.dimensions[0].type === 'TIME';
    };
    var fetchDimensions = function fetchDimensions(cfg) {
      cfg = cfg || {};
      var path = "/line-chart/dimensions";
      var params = cfg.params;
      var dimensionFetch = CardQueryResource.getWithProgress(path, cfg.cardId, params, cfg.cardToPreview, 'line-chart-' + cfg.cardId);
      return dimensionFetch.then(function (response) {
        if (cfg.cardConfig && cfg.cardConfig.includeUnfilteredLine) {
          response.results[0].result.data.unshift({
            values: [{
              value: -1,
              label: 'Unfiltered'
            }],
            aggregations: []
          });
        }
        return response;
      });
    };
    var getTimePointValue = function getTimePointValue(value, dimension) {
      var format;
      switch (dimension.timePeriod) {
        case "DAY":
          format = "YYYY-DDD";
          break;
        case "WEEK":
          format = "YYYY-WW";
          break;
        case "MONTH":
          format = "YYYY-MM";
          break;
        case "YEAR":
          format = "YYYY";
          break;
        default:
          format = null;
          break;
      }
      if (!format && !value.time) {
        if (validateMoment(value.label)) {
          return momentToDate(value.label);
        }
      }
      return !format ? utcToDate(value.time) : utcToDate(value.value, format);
    };
    var getYAxisFromMeasure = function getYAxisFromMeasure(measure) {
      if (AggUtils.isDurationBasedMeasure(measure)) {
        return 'time';
      }
      if (AggUtils.isPercentageBasedMeasure(measure)) {
        return 'score';
      }
      return 'default';
    };
    var getSeriesPoint = function getSeriesPoint(xValue, aggregation, measure, dimensionName, stats) {
      var value = aggregation.value === undefined ? null : aggregation.value;
      if (measure && measure.valueProducer && ["TIME_BETWEEN", "TIME_IN_APP"].indexOf(measure.valueProducer.type) !== -1 && value) {
        //time between measure returns milliseconds
        //and the compact time used to display the axis values expects centiseconds
        value = value / 10;
      }
      if (measure && measure.aggregation && measure.aggregation.type === "GROUP_PERCENT" && value) {
        // display as percentage from 0 to 100
        value = value * 100;
      }
      return {
        x: xValue,
        y: value,
        name: AggUtils.getMeasureValueDisplay(aggregation, measure, stats),
        dimensionName: dimensionName
      };
    };
    var sortAndTrimSeriesData = function sortAndTrimSeriesData(s, config) {
      //sort the data by time (xAxis) so highcharts is happy
      s.data = sortBy(s.data, function (d) {
        return d.x;
      });
      if (s.data && s.data.length) {
        //trim beginning where y is null so we don't have long axis
        while (s.data.length && isNull(s.data[0].y)) {
          s.data.shift();
        }
        //trim end where y is null so we don't have long axis
        while (s.data.length && isNull(s.data[s.data.length - 1].y)) {
          s.data.pop();
        }
      }
      var timePeriodToFormat = {
        "WEEK": "YYYY-WW",
        "MONTH": "YYYY-MM",
        "YEAR": "YYYY",
        "DAY": "YYYY-DDD"
      };

      //fill in nulls between points so that highcharts doesn't draw a line between them
      if (config && (config.allowGaps || config.fillGapsWithZeroes)) {
        forEach(config.dimensions, function (dimension) {
          if (!dimension.timePeriod) {
            return;
          }
          var dateFormat = timePeriodToFormat[dimension.timePeriod] || timePeriodToFormat.DAY;

          //get the expected x distance between two points
          var lastXVal = s.data[0].x;
          var xDistance = duration(1, dimension.timePeriod.toLowerCase());

          //if this is in months we need to add some padding
          if (xDistance.months() === 1) {
            xDistance = xDistance + duration(1, 'day');
          }
          for (var i = 0; i < s.data.length; i++) {
            //check if the distance between points is more than the dimension (day, week, month ...)
            if (utc(lastXVal) + xDistance < utc(s.data[i].x)) {
              //add a null point here so that the gap does not have a line
              var currentMoment = utc(utc(lastXVal) + xDistance);
              var lastMoment = s.data[i].x;
              var MAX_GAP_SIZE = 100;
              var gapSize = Math.abs(currentMoment.diff(lastMoment, dimension.timePeriod.toLowerCase()));
              if (gapSize > MAX_GAP_SIZE) {
                Logger.warn("gapSize of ".concat(gapSize, " exceeds maximum gap size of ").concat(MAX_GAP_SIZE, ". Stopping in order to prevent browser render failure."));
                continue;
              }
              if (!config.fillGapsWithZeroes) {
                lastMoment = currentMoment + xDistance;
              }
              while (currentMoment < lastMoment) {
                s.data.splice(i, 0, {
                  x: currentMoment,
                  y: null,
                  name: null,
                  dimensionName: AggUtils.getDimensionDisplay(currentMoment.format(dateFormat), dimension)
                });

                //adjust our index
                i++;
                currentMoment = utc(currentMoment + xDistance);
              }
              --i;
            }
            lastXVal = s.data[i].x;
          }

          //replace every null y value with 0 if the config calls for it
          if (config.fillGapsWithZeroes) {
            forEach(s.data, function (d) {
              if (d.y === null) {
                d.y = 0;
                d.name = 0;
              }
            });
          }
        });
      }
    };
    var getChartYDomainBounds = function getChartYDomainBounds(cfg) {
      if (isArray(cfg.chartAxisBoundaries)) {
        var yAxisBoundaries = findWhere(cfg.chartAxisBoundaries, {
          "axis": 'y'
        });
        if (yAxisBoundaries) {
          return [yAxisBoundaries.min, yAxisBoundaries.max];
        }
      }
    };
    var configureYAxisForMeasure = function configureYAxisForMeasure(chart, cfg, i) {
      var defaultColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var j = isArray(i) ? i[1] : i;
      var m = isArray(i) ? i[0] : cfg.measures[i];
      var yAxisId = getYAxisFromMeasure(m);
      var yAxis = findWhere(chart.yAxis, {
        "id": yAxisId
      });
      var chart_y_domain_bounds = getChartYDomainBounds(cfg);
      if (yAxis) {
        var clamp_y = clamp(chart_y_domain_bounds);
        var measure_min = AggUtils.getMeasureMinValueOrDefault(m, yAxis.min);
        var measure_max = AggUtils.getMeasureMaxValueOrDefault(m, yAxis.max);
        if (isArray(chart_y_domain_bounds)) {
          yAxis.min = chart_y_domain_bounds[0];
        }
        if (isArray(chart_y_domain_bounds)) {
          yAxis.max = chart_y_domain_bounds[1];
        }
        if (existy(measure_min)) {
          yAxis.min = clamp_y(measure_min);
        }
        if (existy(measure_max)) {
          yAxis.max = clamp_y(measure_max);
        }
      }
      return {
        name: $sanitize(m.name),
        data: [],
        color: ChartUtils.getSeriesColor(cfg, j, defaultColor, m),
        yAxis: yAxisId
      };
    };
    var configureYAxis = function configureYAxis(chart, config, mi) {
      if (!isUndefined(mi)) {
        return [configureYAxisForMeasure(chart, config, mi, getColorOption(mi))];
      } else {
        return Array.from(config.measures, function (m, i) {
          return configureYAxisForMeasure(chart, config, [m, i]);
        });
      }
    };
    var getLineChart = function getLineChart(data, config, stats, mi, eventLines) {
      //mi is the index of the measure being graphed
      //if undefined graph all of them, otherwise only graph the one we are referring to using mi

      if (isUndefined(mi) && config.includeUnfilteredLine && config.dimensions.length === 1 && $location.search().filter) {
        config = angular.copy(config);
        var newMeasures = [];
        forEach(config.measures, function (m) {
          newMeasures.push({
            name: 'Unfiltered ' + m.name,
            aggregation: m.aggregation,
            valueProducer: m.valueProducer
          });
          if (m.name && m.name.indexOf('Filtered ') !== 0) {
            m.name = 'Filtered ' + m.name;
          }
        });
        config.measures = newMeasures.concat(config.measures);
        var hiddenMeasures = config.hiddenMeasures;
        if (hiddenMeasures && hiddenMeasures.length) {
          config.hiddenMeasures = hiddenMeasures.concat(map(hiddenMeasures, function (i) {
            return i + newMeasures.length;
          }));
        }
      }
      var timeBasedDimension = isTimeBasedDimension(config);
      var chart = {
        chart: {
          defaultSeriesType: config.line ? 'line' : 'area',
          borderWidth: 0,
          backgroundColor: '#fff',
          plotBackgroundColor: '#fff',
          alignTicks: false,
          zoomType: 'xy',
          resetZoomButton: {
            position: {
              x: -15,
              y: 15
            },
            relativeTo: 'chart',
            theme: {
              fill: wsColors.wsBlue,
              style: {
                color: 'white'
              },
              r: 3,
              states: {
                hover: {
                  fill: wsColors.wsBlueLight,
                  style: {
                    color: '#333'
                  }
                }
              }
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: !isUndefined(mi) ? $sanitize(config.measures[mi].name) : null,
          align: 'center'
        },
        tooltip: {
          shared: true,
          padding: 0,
          formatter: function formatter() {
            var tool = "";
            var isEventLine = isUndefined(this.x) && isUndefined(this.x);
            if (isEventLine) {
              tool += '<div class="watershed-tooltip">' + this.points[0].point.eventTooltipText + '</div>';
            } else {
              tool += '<div class="watershed-tooltip" ><table><thead><tr><th>' + this.points[0].point.dimensionName + '</th></tr></thead>';
              forEach(this.points, function (p) {
                return tool += '<tr style="color:' + p.series.color + '"><td>' + p.series.name + ':</td>' + '<td>' + p.point.name + '</td></tr>';
              });
              tool += '</table></div>';
            }
            return tool;
          }
        },
        plotOptions: {
          series: {
            shadow: false,
            stickyTracking: false,
            connectNulls: !config.allowGaps && !config.fillGapsWithZeroes
          }
        },
        xAxis: {
          title: {
            text: null
          },
          type: timeBasedDimension ? 'datetime' : 'category',
          categories: timeBasedDimension ? undefined : [],
          tickLength: 0,
          minorTickLength: 0,
          gridLineWidth: 1,
          showLastLabel: true,
          showFirstLabel: true,
          lineWidth: 1,
          plotLines: map(eventLines.data, function (line) {
            return {
              label: {
                text: line.lineText,
                style: {
                  fontSize: '10px'
                }
              },
              tooltipText: line.tooltipText,
              color: line.color,
              width: line.width,
              value: Date.parse(line.value),
              events: {
                mouseover: function mouseover(e) {
                  var series = this.axis.series[0];
                  var chart = series.chart;
                  var PointClass = series.pointClass;
                  var tooltip = chart.tooltip;
                  var point = new PointClass().init(series);
                  var normalizedEvent = chart.pointer.normalize(e);
                  point.tooltipPos = [normalizedEvent.chartX - chart.plotLeft, normalizedEvent.chartY - chart.plotTop];
                  point.eventTooltipText = this.options.tooltipText;
                  // Since the series tooltip is shared, the formatter expects an array
                  point = [point];
                  tooltip.refresh(point);
                },
                mouseout: function mouseout() {
                  this.axis.chart.tooltip.hide();
                }
              }
            };
          })
        },
        yAxis: [{
          id: 'default',
          allowDecimals: config.displayAxisDecimals,
          title: {
            rotation: -90,
            margin: 10,
            text: null
          },
          tickLength: 3,
          minorTickLength: 0,
          lineWidth: 1,
          gridLineWidth: 1
        }, {
          id: 'time',
          title: {
            rotation: -90,
            margin: 10,
            text: null
          },
          type: 'datetime',
          opposite: true,
          tickLength: 3,
          minorTickLength: 0,
          lineWidth: 1,
          gridLineWidth: 1,
          labels: {
            formatter: function formatter() {
              return $filter('compactTime')(this.value, stats && stats[0] && stats[0].max < 1000);
            }
          }
        }, {
          id: 'score',
          allowDecimals: false,
          title: {
            rotation: -90,
            margin: 10,
            text: null
          },
          opposite: true,
          max: 1,
          tickLength: 3,
          minorTickLength: 0,
          lineWidth: 1,
          gridLineWidth: 1,
          tickInterval: 0.1,
          labels: {
            formatter: function formatter() {
              return this.value * 100 + '%';
            }
          }
        }],
        series: null
      };
      chart.series = configureYAxis(chart, config, mi);

      //the first dimension should always be time based here
      if (config.dimensions.length === 1) {
        forEach(data, function (d) {
          var dimName = AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0]);
          var time = timeBasedDimension ? getTimePointValue(d.values[0], config.dimensions[0]) : undefined;
          if (!timeBasedDimension) {
            chart.xAxis.categories.push(dimName);
          }
          if (!isUndefined(mi)) {
            chart.series[0].dimensionName = dimName;
            chart.series[0].data.push(getSeriesPoint(time, d.aggregations[mi], config.measures[mi], dimName, stats[mi]));
          } else {
            forEach(d.aggregations, function (a, i) {
              if (config.hiddenMeasures.indexOf(i) > -1) {
                return;
              }
              chart.series[i].dimensionName = dimName;
              chart.series[i].data.push(getSeriesPoint(time, a, config.measures[i], dimName, stats[i]));
            });
          }
        });
        if (isUndefined(mi)) {
          chart.series = filter(chart.series, function (s, i) {
            return config.hiddenMeasures.indexOf(i) === -1;
          });
        }
        forEach(chart.series, function (s, i) {
          sortAndTrimSeriesData(s, config);
          s.color = chart.series[i].color ? chart.series[i].color : ChartUtils.getSeriesColor(config, i);
        });
      } else if (config.dimensions.length === 2) {
        //the second dimension is optional, if it is included the series should be seperated based on this dimension
        //each value for the second dimension gets its own series (ie each person, each group...)
        var series = {};
        var dimensionIndex = 0;
        forEach(data, function (d) {
          var dimName = AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0]);
          var time = getTimePointValue(d.values[0], config.dimensions[0]);
          var dim2 = d.values[1];
          var dim2Label = AggUtils.getDimensionDisplay(dim2, config.dimensions[1]);
          if (isUndefined(dim2.value)) {
            return;
          }
          if (isUndefined(mi)) {
            forEach(config.measures, function (m, i) {
              if (config.hiddenMeasures.indexOf(i) === -1 && !series.hasOwnProperty(dim2.value + '-' + i)) {
                series[dim2.value + '-' + i] = {
                  name: dim2Label + ' ' + m.name,
                  yAxis: getYAxisFromMeasure(m),
                  color: ChartUtils.getSeriesColor(config, dimensionIndex++, null, m),
                  data: []
                };
              }
            });
          } else {
            if (!series.hasOwnProperty(dim2.value)) {
              series[dim2.value] = {
                name: dim2Label + ' ' + config.measures[mi].name,
                yAxis: getYAxisFromMeasure(config.measures[mi]),
                color: ChartUtils.getSeriesColor(config, mi, null, config.measures[mi]),
                data: []
              };
            }
          }
          if (!isUndefined(mi)) {
            series[dim2.value].data.push(getSeriesPoint(time, d.aggregations[mi], config.measures[mi], dimName, stats[mi]));
          } else {
            forEach(d.aggregations, function (a, i) {
              if (config.hiddenMeasures.indexOf(i) > -1) {
                return;
              }
              //new series for each measures here!!!!!
              series[dim2.value + '-' + i].data.push(getSeriesPoint(time, a, config.measures[i], dimName, stats[mi]));
            });
          }
        });
        chart.series = chain(series).values().sortBy(function (s) {
          return s.data.length;
        }).reverse().value();
        var dashStyles = ['Solid', 'ShortDash', 'ShortDot', 'ShortDashDot', 'ShortDashDotDot', 'Dot', 'Dash', 'LongDash', 'DashDot', 'LongDashDot', 'LongDashDotDot'];

        //any series that have the same color should have different line dash styles
        chain(chart.series).groupBy('color').each(function (val) {
          forEach(val, function (v, i) {
            v.dashStyle = dashStyles[i % dashStyles.length];
          });
        });
        forEach(chart.series, function (s) {
          return sortAndTrimSeriesData(s, config);
        });
      }
      if (config.cumulativeSum) {
        forEach(chart.series, function (s, i) {
          s.name = s.name + " (Cumulative)";
          forEach(s.data, function (d, di, list) {
            d.y = di > 0 ? d.y + list[di - 1].y : d.y;
            d.name = AggUtils.getMeasureValueDisplay({
              value: d.y
            }, config.measures[i]);
          });
        });
      }

      //
      // set optional benchmark plotLines and min/max (from measures)
      //
      function addBenchmark(benchmark, i, yAxis, bmColor) {
        // get benchmark value
        var bm_value = ChartUtils.getSimpleValue(benchmark);
        if (bm_value === null) {
          return;
        }

        // configure plotLine
        var plotLine = {
          value: bm_value,
          color: bmColor || getColorOption(i),
          dashStyle: bmColor ? 'Solid' : 'LongDash',
          width: 2,
          id: 'benchmark-' + i,
          index: i
        };

        // add plotLine to yAxis
        yAxis.plotLines = yAxis.plotLines || [];
        yAxis.plotLines.push(plotLine);

        //add an invisible point so benchmark is displayed if it happens to fall outside of min/max
        chart.series.push({
          showInLegend: false,
          marker: {
            enabled: false
          },
          enableMouseTracking: false,
          data: [{
            x: Utils._try(function () {
              return chart.series[0].data[0].x;
            }, null),
            y: bm_value
          }]
        });
      }
      function enableMeasureDisplayOptions(m, seriesIndex, bmColor) {
        if (!chart || !chart.series || chart.series.length < seriesIndex + 1) {
          return;
        }

        // determine which yAxis to apply to
        var yAxisId = chart.series[seriesIndex].yAxis;
        var yAxis = yAxisId ? findWhere(chart.yAxis, {
          id: yAxisId
        }) : chart.yAxis[0];
        addBenchmark(m.benchmark, seriesIndex, yAxis, bmColor);

        // todo: set soft min/max based on chart range & benchmark(s)

        // set "hard" min/max specified on measures
        ChartUtils.setAxisMin(m.min, yAxis);
        ChartUtils.setAxisMax(m.max, yAxis);
      }

      // todo: implement config-based benchmark, min/max specified by axis id
      // where config-based benchmark takes precedence over measure-based benchmarks

      // if single measure on this chart...
      if (angular.isDefined(mi)) {
        enableMeasureDisplayOptions(config.measures[mi], 0, 'red');

        // else, check each measure for benchmark, min/max
      } else {
        var bmColor = config.measures.length === 1 ? 'red' : undefined;
        forEach(config.measures, function (m, i) {
          return enableMeasureDisplayOptions(m, i, bmColor);
        });
      }
      if (Array.isArray(data) && data.length === 0) {
        chart.noData = true;
      }
      return chart;
    };
    return assignMethods({}, [['fetchData', fetchData], ['ensureDataSize', ensureDataSize], ['getStatementDownloadUrl', getStatementDownloadUrl], ['isTimeBasedDimension', isTimeBasedDimension], ['fetchDimensions', fetchDimensions], ['getLineChart', getLineChart]]);
  }]);
})();
